import { render, staticRenderFns } from "./user-stats.vue?vue&type=template&id=ae7ddad2&"
import script from "./user-stats.vue?vue&type=script&lang=js&"
export * from "./user-stats.vue?vue&type=script&lang=js&"
import style0 from "./user-stats.vue?vue&type=style&index=0&id=ae7ddad2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports